/**
 * 工作台两态（定稿）：个人 vs 公司
 * - 个人：不传 X-Company-Id；权限 = 「个人用户」Spatie ∪ resource_grants / registrationFormGrants
 * - 公司：传 X-Company-Id；权限 = 该公司 Spatie，完全忽略 ACL
 * ACL 不是独立工作台，仅为个人模式下的附加数据源
 */

// 个人空间已下线，保留常量/函数仅兼容尚未更新的调用方。
export const WORKSPACE_SCOPE_COMPANY = 'company'

const STORAGE_KEY_SCOPE = 'workspaceScope'

/** @returns {'company'} */
export function readWorkspaceScope () {
  return WORKSPACE_SCOPE_COMPANY
}

export function isCompanyWorkspace () {
  return readWorkspaceScope() === WORKSPACE_SCOPE_COMPANY
}

/** 切换到个人空间：保留 currentCompanyId 供「切换回公司」恢复请求头 */
/** 切换到公司空间 */
export function setCompanyWorkspace () {
  localStorage.setItem(STORAGE_KEY_SCOPE, WORKSPACE_SCOPE_COMPANY)
}

export function clearWorkspaceScope () {
  localStorage.removeItem(STORAGE_KEY_SCOPE)
}

/**
 * 无关联公司时强制个人空间；有公司时保留用户已选 personal/company
 * @param {number} companyCount
 * @returns {'personal' | 'company'}
 */
export function syncWorkspaceScopeWithCompanies (companyCount) {
  const n = Number(companyCount) || 0
  if (n <= 0) localStorage.removeItem('currentCompanyId')
  setCompanyWorkspace()
  return WORKSPACE_SCOPE_COMPANY
}

/**
 * 请求拦截器用：仅在公司空间且存在有效 companyId 时返回 id
 * @returns {string|null}
 */
export function getWorkspaceCompanyIdForRequest () {
  const raw = localStorage.getItem('currentCompanyId')
  if (raw == null || raw === '') return null
  const n = Number(raw)
  if (!Number.isInteger(n) || n <= 0) return null
  return String(n)
}
